import React from 'react';
import './IntroSection.css';

const IntroSection: React.FC = () => (
  <div className="intro-section">
    <div className="intro-image" />
    <div className="intro-text">
      <h2>Too busy to stay in queues?</h2>
      <p>
        In the hustle and bustle of your busy work week, taking your car to a car wash 
        or the detailers and waiting for it to get refurbished is the last thing anyone 
        wants to do. We know that keeping your car looking new and reconditioned is important to you. 
        Our goal is to make getting your car detailed less of a chore for you!
      </p>
      <p>
        At Yenro Auto Mobile Car Detailing, we provide premium car detailing with a reliable 
        and insured service. What makes us different from the rest? We offer reliable 
        service with a 100% money-back guarantee in the unlikely case you are not satisfied 
        with the result. Allow us to perfect our job or, if you aren’t satisfied, make 
        use of our money-back policy.
      </p>
    </div>
  </div>
);

export default IntroSection;
